// @flow

import {
  BrowseCardTypeOptions,
  BrowseDropdownListingTypeOptions,
  SortByOptions,
} from '../Constants/Browse/BrowseConstants';
export const BrowseParameters = Object.freeze({
  BrowseCardType: 'browseCardType',
  BrowseSortBy: 'browseSortBy',
  BrowseCategories: 'browseCategories',
  BrowseStates: 'browseStates',
  BrowseProductOrService: 'browseProductOrService',
  BrowseListingType: 'browseListingType',
  BrowseOffset: 'offset',
  BrowsePage: 'page',
  BrowseFeatured: 'featured',
  CardFeatured: 'card_featured',
});

export const SearchParameters = Object.freeze({
  SearchCategories: 'card_categories',
  SearchLocation: 'mapLocation',
  SearchCardType: 'postType',
  SearchKeyword: 'searchStringText',
  SearchZoom: 'zoom',
});

const generateDefaultCriteria = (parameters: Object): Object =>
  Object.keys(parameters).reduce((acc, key) => {
    const param = parameters[key];
    acc[param] = '';
    return acc;
  }, {});

const customSearchDefaults = {
  card_categories: [],
  zoom: 5,
  searchStringText: '',
  sortBy: SortByOptions.Nearest,
};

const customBrowseDefaults = {
  browseCategories: [],
  browseStates: [],
  browsePage: 1,
  browseSortBy: SortByOptions.MostRecent,
};

export const defaultSearchCriteria = {
  ...generateDefaultCriteria(SearchParameters),
  ...customSearchDefaults,
};

export const defaultBrowseCriteria = {
  ...generateDefaultCriteria(BrowseParameters),
  ...customBrowseDefaults,
};

export const DEFAULT_BROWSE_FILTER_BAR_OPTIONS = {
  buyingOrSelling: BrowseDropdownListingTypeOptions.ImBuying,
  cardType: BrowseCardTypeOptions.Listings,
  categories: [],
  sortBy: SortByOptions.MostRecent,
  states: [],
};
